"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeveloperPreview = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const PreviewBadge_1 = require("./PreviewBadge");
const docs_links_1 = require("../../config/docs_links");
const DeveloperPreview = (props) => {
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(PreviewBadge_1.PreviewBadge, Object.assign({ text: t('ai:Developer Preview'), popoverContent: t('ai:Developer preview features are not intended to be used in production environments. The clusters deployed with the developer preview features are considered to be development clusters and are not supported through the Red Hat Customer Portal case management system.'), externalLink: docs_links_1.DEVELOPER_SUPPORT_LEVEL_LINK }, props)));
};
exports.DeveloperPreview = DeveloperPreview;
exports.DeveloperPreview.displayName = 'DeveloperPreview';
//# sourceMappingURL=DeveloperPreview.js.map